import styled from '@emotion/styled'

export const BlockedEInvoiceEmptyStateWrapper = styled.section`
  height: 624px;
`
